import { initOrganizationFilter } from "./initOrganizationFilter";

export const reportFilters = {
  initOrganizationFilter,
};
